// src/pages/AccessDenied.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const AccessDenied = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center px-4">
      <h1 className="text-4xl font-bold text-red-600 mb-4">Access Denied</h1>
      <p className="text-gray-700 mb-6">
        You do not have permission to access this page.
      </p>
      <Link
        to="/"
        className="text-talexo-blue hover:underline font-medium"
      >
        Go to Home
      </Link>
    </div>
  );
};

export default AccessDenied;
